import { useMemo } from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { fetchStripeExpressSession } from 'api/account';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const useStripeExpress = () => {
    const { accountId } = useCurrentAccount();

    return useMemo(
        () =>
            loadConnectAndInitialize({
                publishableKey: import.meta.env.VITE_DASHBOARD_STRIPE_CONNECT_KEY,
                fetchClientSecret: async () => {
                    const session = await fetchStripeExpressSession(accountId);
                    if (session) {
                        return session.session_token;
                    }
                    throw new Error('Failed to fetch session token');
                },
            }),
        [accountId],
    );
};

export { useStripeExpress };
